"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _styled = /*#__PURE__*/ _interop_require_default(require("@emotion/styled"));
var _utils = require("@collinsonx/utils");
var _core = require("@mantine/core");
var _colourconstantspartner = /*#__PURE__*/ _interop_require_default(require("../../../colour-constants-partner"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _tagged_template_literal_loose(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    strings.raw = raw;
    return strings;
}
function _templateObject() {
    var data = _tagged_template_literal_loose([
        "\n    width: 100%;\n    height: 160px;\n    ",
        "\n    background-color: ",
        ";\n    position: relative;\n    background-size: ",
        "\n\n    background-repeat: no-repeat;\n    background-position: center;\n    transition: all 0.3s ease-in-out;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal_loose([
        "\n  border-radius: 8px;\n  padding: 4px 8px 4px 8px;\n  color: ",
        ";\n  background-color: ",
        ";\n  font-size: 16px;\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  min-width: 33px;\n  height: 33px;\n  display: flex;\n  justify-content: center;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
var Container = _styled.default.div(_templateObject(), function(param) {
    var src = param.src, status = param.status;
    return "\n        " + (src ? 'background-image: url("' + src + '");' : "") + "\n        " + (status === _utils.OutletStatus.Inactive ? "filter: grayscale(100%);" : "") + "\n\n    ";
}, _colourconstantspartner.default["grey-border"], function(param) {
    var hasPadding = param.hasPadding;
    return "\n      " + (hasPadding ? "cover" : "100%") + ";\n    ";
});
var ImageCount = _styled.default.div(_templateObject1(), _colourconstantspartner.default["text-default"], (0, _core.rgba)("#FFF", 0.7));
var CardImage = function(props) {
    var imageCount = props.imageCount, alt = props.alt, hasPadding = props.hasPadding;
    var tooltip = imageCount ? /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Tooltip, {
        label: "Image" + (Number(imageCount) > 1 ? "s" : ""),
        position: "bottom",
        arrowPosition: "center",
        arrowSize: 6,
        withinPortal: true,
        withArrow: true,
        zIndex: 405,
        children: /*#__PURE__*/ (0, _jsxruntime.jsx)(ImageCount, {
            children: imageCount
        })
    }) : null;
    var image = /*#__PURE__*/ (0, _jsxruntime.jsx)(Container, _extends({
        role: "img",
        className: "card-image",
        "aria-label": alt
    }, props, {
        children: tooltip
    }));
    return hasPadding ? /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Box, {
        p: 24,
        style: {
            borderBottom: "1px solid " + _colourconstantspartner.default["grey-border"]
        },
        children: image
    }) : image;
};
var _default = CardImage;
